import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from "react-hot-toast";
import Box from '../../components/Box';
import { MenuComponent } from '../../_metronic/assets/ts/components';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import Content from '../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../_metronic/layout/core';
import { ToolbarWrapper } from '../../_metronic/layout/components/toolbar';
import { storeActivityIndicator } from '../../redux/reducers/authSlice';
import { RootState } from '../../redux/store';
import RefreshButton from '../../components/RefreshButton';
import ColumnChooser from '../../components/ColumnChooser';
import TableConstantActions from '../../components/TableConstantActions';
import CustomTextInput from '../../components/CustomTextInput';
import CustomSwitch from '../../components/CustomSwitch';
import { ColumnChooserModel } from '../../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../../models/common/ColumnFilterModel';
import { kolonlariBirlestir } from '../../components/ColumnFilter/kolonBirlestir';
import ColumnFilterRow from '../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, foldText } from '../../components/ColumnFilter/ColumnFilterTypes';
import { useSortableColumns } from '../../helpers/useSortableColumns';
import { VardiyaPlaniItem, VardiyaService, VardiyaTanimiItem } from '../../services/VardiyaService';
import { desenHatasi, desenKodlari, vardiyaRengi } from '../../helpers/vardiyaDesen';

const EVET_HAYIR = [{ value: '1', label: 'Evet' }, { value: '0', label: 'Hayır' }];

/** Hazır desenler: formda tek tıkla doldurulur (kodlar tanımlı değilse sunucu uyarır). */
const ORNEKLER = [
    { ad: 'Hafta içi sabah', desen: 'S,S,S,S,S,HT,HT' },
    { ad: 'İkili dönen (haftalık)', desen: 'S,S,S,S,S,HT,HT,AK,AK,AK,AK,AK,HT,HT' },
    { ad: 'Üçlü dönen (2-2-2-2)', desen: 'S,S,AK,AK,G,G,HT,HT' },
];

/** Ekranda süzme / sıralama için satırın kolon değeri. */
const kolonDegeri = (x: VardiyaPlaniItem, kolon: string): string => {
    switch (kolon) {
        case 'ad': return x.ad;
        case 'desen': return x.desen;
        case 'gunSayisi': return String(x.gunSayisi).padStart(3, '0');
        case 'uyarilar': return x.uyarilar.length > 0 ? '1' : '0';
        case 'aktif': return x.aktif ? '1' : '0';
        case 'atamaSayisi': return String(x.atamaSayisi).padStart(6, '0');
        default: return '';
    }
}

interface EkranFiltresi {
    sortColumn?: string
    sortDirection?: string
    columnFilters: ColumnFilterModel[]
}

/** Desenin renkli gün kutucukları (önizleme). */
export const DesenSeridi = ({ desen, kodlar }: { desen: string, kodlar: string[] }) => (
    <div className='d-flex flex-wrap gap-1'>
        {desenKodlari(desen).map((k, i) =>
            <span key={i} title={`${i + 1}. gün`} className='badge ebbe-status-badge' style={{ ...vardiyaRengi(k, kodlar), minWidth: 30, justifyContent: 'center' }}>{k}</span>
        )}
    </div>
);

/**
 * Vardiya Planları (İnsan Kaynakları > Tanımlamalar, Faz 2, 03.11.2026). Desen gün gün vardiya kodlarıdır, HT hafta tatili;
 * personele atanınca başlangıç günü desenin 1. günü olur ve desen döner. Yasal uyarılar (11 saat dinlenme, 7 gün üst üste) kaydı durdurmaz.
 */
const VardiyaPlaniList = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "İnsan Kaynakları > Tanımlamalar > Vardiya Planları"
    const pageVersion = "1";
    const menu = auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName);
    const formRef = useRef<any>(null);

    const [liste, setListe] = useState<VardiyaPlaniItem[]>([]);
    const [vardiyalar, setVardiyalar] = useState<VardiyaTanimiItem[]>([]);
    const [filter, setFilter] = useState<EkranFiltresi>({ sortColumn: 'ad', sortDirection: 'asc', columnFilters: [] });

    const [isOpen, setIsOpen] = useState(false);
    const [duzenlenenId, setDuzenlenenId] = useState<string | undefined>(undefined);
    const [ad, setAd] = useState<string | undefined>(undefined);
    const [desen, setDesen] = useState<string | undefined>(undefined);
    const [aktif, setAktif] = useState<boolean>(true);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Plan', name: 'ad', order: 0, isVisible: true },
            { title: 'Desen', name: 'desen', order: 0, isVisible: true },
            { title: 'Gün', name: 'gunSayisi', order: 0, isVisible: true },
            { title: 'Uyarı', name: 'uyarilar', order: 0, isVisible: true },
            { title: 'Aktif', name: 'aktif', order: 0, isVisible: true },
            { title: 'Atanan', name: 'atamaSayisi', order: 0, isVisible: true },
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
        getData();
    }, [])

    const getData = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var [planlar, tanimlar] = await Promise.all([VardiyaService.planListesi(), VardiyaService.tanimListesi()]);

            if (!planlar.isSuccess) {
                toast.error(planlar.message ?? '');
                return;
            }

            setListe((planlar.data ?? []).map(x => ({ ...x, isSelected: false })));
            if (tanimlar.isSuccess)
                setVardiyalar(tanimlar.data ?? []);
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const kodlar = vardiyalar.map(x => x.kod);

    const gorunen = liste.filter(x => (filter.columnFilters ?? []).every(f => {
        if (f.values && f.values.length > 0)
            return f.values.includes(kolonDegeri(x, f.column));

        if (f.text && f.text.trim())
            return foldText(kolonDegeri(x, f.column)).includes(foldText(f.text.trim()));

        return true;
    })).sort((a, b) => {
        if (!filter.sortColumn)
            return 0;

        var r = kolonDegeri(a, filter.sortColumn).localeCompare(kolonDegeri(b, filter.sortColumn), 'tr');
        return filter.sortDirection == 'desc' ? -r : r;
    });

    const sortableColumns = ['ad', 'gunSayisi', 'uyarilar', 'aktif', 'atamaSayisi'];
    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, (f?: EkranFiltresi) => { if (f) setFilter(f); });

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        ad: { type: 'text' },
        desen: { type: 'text' },
        uyarilar: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(EVET_HAYIR) },
        aktif: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(EVET_HAYIR) },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => setFilter({ ...filter, columnFilters });

    const setItemSelected = (_id: string) => setListe(liste.map(x => x.vardiyaPlaniId == _id ? { ...x, isSelected: !x.isSelected } : x));

    const selectAll = () => {
        var ids = gorunen.map(x => x.vardiyaPlaniId);
        var isAllSelected = gorunen.length > 0 && gorunen.every(x => x.isSelected);
        setListe(liste.map(x => ids.includes(x.vardiyaPlaniId) ? { ...x, isSelected: !isAllSelected } : x));
    }

    const secililer = liste.filter(x => x.isSelected);

    const scrollTo = () => setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);

    const formuDoldur = (o: VardiyaPlaniItem | undefined) => {
        setDuzenlenenId(o?.vardiyaPlaniId);
        setAd(o?.ad);
        setDesen(o?.desen);
        setAktif(o?.aktif ?? true);
    }

    const yeniEkle = () => { formuDoldur(undefined); setIsOpen(true); scrollTo(); }
    const iptalEt = () => { formuDoldur(undefined); setIsOpen(false); }

    const ac = (o: VardiyaPlaniItem | undefined) => {
        if (!o || !menu?.canUpdate)
            return;
        formuDoldur(o);
        setIsOpen(true);
        scrollTo();
    }

    const formHatasi = desen && desen.trim() != '' ? desenHatasi(desen, kodlar) : null;

    const kaydet = async () => {
        try {
            if (!ad || ad.trim() == '') { toast.error("Plan adı zorunludur."); return; }
            var hata = desenHatasi(desen, kodlar);
            if (hata) { toast.error(hata); return; }

            dispatch(storeActivityIndicator(true));

            var response = await VardiyaService.planKaydet({ vardiyaPlaniId: duzenlenenId ?? null, ad: ad.trim(), desen: desen!, aktif });

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            var uyari = response.data?.uyarilar ?? [];
            toast.success(uyari.length > 0 ? `Plan kaydedildi. ${uyari.length} yasal uyarı var; listede görünür.` : "Plan kaydedildi.");
            iptalEt();
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const sil = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var response = await VardiyaService.planSil(secililer.map(x => x.vardiyaPlaniId));

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success("Seçilen planlar silindi.");
            iptalEt();
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const hucre = (item: VardiyaPlaniItem, column: string) => {
        var icerik: React.ReactNode;

        if (column == 'ad')
            icerik = item.ad;
        else if (column == 'desen')
            icerik = <DesenSeridi desen={item.desen} kodlar={kodlar} />;
        else if (column == 'gunSayisi')
            icerik = item.gunSayisi;
        else if (column == 'uyarilar')
            icerik = item.uyarilar.length == 0
                ? <span className='text-muted'>–</span>
                : <div className='text-danger fs-8'>{item.uyarilar.map((u, i) => <div key={i}>{u}</div>)}</div>;
        else if (column == 'aktif')
            icerik = <span className={'badge ebbe-status-badge ' + (item.aktif ? 'badge-light-primary' : 'badge-light')}>{item.aktif ? 'Aktif' : 'Pasif'}</span>;
        else if (column == 'atamaSayisi')
            icerik = item.atamaSayisi;

        return <td key={column} onClick={() => setItemSelected(item.vardiyaPlaniId)} onDoubleClick={() => ac(item)}>{icerik}</td>;
    }

    const gorunenKolonlar = columns.filter(x => x.isVisible).sort((a, b) => a.order - b.order);

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />

                <TableConstantActions
                    deleteFunction={sil}
                    onSearchSubmit={(e) => e.preventDefault()}
                    pageName={pageName}
                    hideSearch={true}
                    searchTerm=''
                    selectedCount={secililer.length}
                    setSearchTerm={() => { }}
                    updateFunction={() => ac(secililer[0])}
                />

                <ColumnChooser columns={columns} getColumns={getColumns} pageName={pageName} pageVersion={pageVersion} setColumns={setColumns} />

                {
                    menu?.canInsert && (
                        <div className='m-0'>
                            <a onClick={yeniEkle} className='btn btn-sm fw-bold btn-primary'>Yeni Plan Ekle</a>
                        </div>
                    )
                }
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                {
                    isOpen && (
                        <div ref={formRef}>
                            <KTCard className='ebbe-card mb-3'>
                                <KTCardBody>
                                    <h4 className="mb-10 text-black">{duzenlenenId ? 'Planı Güncelle' : 'Yeni Plan'}</h4>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <CustomTextInput labelText="Plan adı" isLabelRequired value={ad} setValue={setAd} />
                                        </div>
                                        <div className="col-md-6">
                                            <CustomTextInput labelText="Desen (gün gün, virgülle)" isLabelRequired value={desen} setValue={setDesen} placeholder="S,S,S,S,S,HT,HT" />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Aktif</label>
                                            <CustomSwitch isActive={aktif} setIsActive={setAktif} />
                                        </div>
                                    </div>

                                    <div className="d-flex flex-wrap align-items-center gap-2 mt-4 fs-7">
                                        <span className='text-muted'>Hazır desen:</span>
                                        {ORNEKLER.map(o => <a key={o.ad} className='btn btn-sm btn-light py-1 px-3' onClick={() => setDesen(o.desen)}>{o.ad}</a>)}
                                    </div>

                                    {
                                        desen && desen.trim() != '' && (
                                            <div className="mt-4">
                                                <DesenSeridi desen={desen} kodlar={kodlar} />
                                                <div className="fs-7 mt-2">
                                                    {formHatasi
                                                        ? <span className='text-danger'>{formHatasi}</span>
                                                        : <span className='text-muted'>{desenKodlari(desen).length} günde bir başa döner.</span>}
                                                </div>
                                            </div>
                                        )
                                    }

                                    <div className="text-muted fs-7 mt-4">
                                        Tanımlı kodlar: {vardiyalar.length == 0 ? 'yok — önce Vardiya Tanımları ekranında vardiya ekleyin' : vardiyalar.map(x => `${x.kod} (${x.baslangic}–${x.bitis})`).join(', ')} · HT hafta tatili.
                                        {' '}Personele atanınca başlangıç günü desenin 1. günüdür. Atanmış plan silinemez; deseni değişirse atanan personelin faturalanmamış mesai kayıtları yeniden hesaplanır.
                                    </div>

                                    <Box flexDirection="row" justifyContent="flex-end" className="mt-5">
                                        <Box mr="15px">
                                            <button className="btn btn-sm btn-light btn-active-light-primary" onClick={iptalEt}>İptal Et</button>
                                        </Box>
                                        <Box>
                                            <button className="btn btn-primary btn-sm" onClick={kaydet}>Kaydet</button>
                                        </Box>
                                    </Box>
                                </KTCardBody>
                            </KTCard>
                        </div>
                    )
                }

                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips columns={columns} definitions={columnFilterDefinitions} filters={filter.columnFilters} onChange={changeColumnFilters} />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={gorunen.length > 0 && gorunen.every(x => x.isSelected)} />
                                                </label>
                                            </div>
                                        </th>
                                        {gorunenKolonlar.map(item => <th key={item.name} {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>)}
                                    </tr>
                                    <ColumnFilterRow columns={gorunenKolonlar} definitions={columnFilterDefinitions} filters={filter.columnFilters} onChange={changeColumnFilters} leadingCellCount={1} />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        gorunen.length == 0 && (
                                            <tr><td className="text-center" colSpan={99}>Kayıt bulunamadı.</td></tr>
                                        )
                                    }
                                    {
                                        gorunen.map(item =>
                                            <tr key={item.vardiyaPlaniId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.vardiyaPlaniId)} className='form-check-input' type='checkbox' checked={item.isSelected ?? false} />
                                                        </label>
                                                    </div>
                                                </td>
                                                {gorunenKolonlar.map(c => hucre(item, c.name))}
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div className="text-muted fs-7 py-3">{gorunen.length} kayıt</div>
                    </KTCardBody>
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default VardiyaPlaniList;
